import ActionAbstract from '../../ActionAbstract';

class ClosePopup extends ActionAbstract {

    static get ID() {
        return 'actions:main:popup:close';
    }

    run(state) {
        return this.composeState(state, {
            main: {
                popupOpen: false
            }
        });
    }

}

export default ClosePopup;